import React from "react";
import TextField from "@mui/material/TextField";
import { blueTextFieldStyles } from "assets/themes/textFieldStyles";

const SolutionTextField = ({
  name,
  label,
  value,
  onChange,
  multiline,
  minRows,
  ...props
}) => {
  return (
    <TextField
      fullWidth
      name={name}
      label={label}
      value={value ?? ""}
      onChange={onChange}
      multiline={multiline}
      minRows={minRows}
      sx={blueTextFieldStyles}
      {...props}
    />
  );
};

export default SolutionTextField;